import { compose } from 'redux'
import { connect } from 'react-redux'
import queryString from 'query-string'
import { withFormik } from 'formik'
import { bindPromiseCreators } from '../../utils/routines'
import * as yup from 'yup'
import '../../utils/validations/extendYup'

import { createResetPasswordPromise } from './routines'
import { withResetPasswordSaga } from './saga'
import ResetPasswordForm from './Forms/ResetPasswordForm'

// connector
const mapDispatchToProps = bindPromiseCreators({
  resetPassword: createResetPasswordPromise
})

const connector = connect(null, mapDispatchToProps)

// formik
const mapPropsToValues = () => ({
  password: ''
})
const validationSchema = yup.object().shape({
  password: yup.string()
    .password()
    .required(),
})
async function handleSubmit(values, {
  setStatus,
  setSubmitting,
  props
}) {
  try {
    const { token } = queryString.parse(props.location.search)
    await props.resetPassword({
      ...values,
      token,
      confirm_password: values.password
    })
    setStatus({ success: true })
  } catch (error) {
    setStatus({ error })
  } finally {
    setSubmitting(false)
  }
}

const formik = withFormik({
  mapPropsToValues,
  validationSchema,
  handleSubmit
})

export default compose(
  withResetPasswordSaga,
  connector,
  formik
)(ResetPasswordForm)
